import { bindMicromodalEventTrigger } from "javascripts/micromodal";

document.addEventListener("DOMContentLoaded", () => {
  bindMicromodalEventTrigger();
});
